import { render, staticRenderFns } from "./evaluate.vue?vue&type=template&id=884fbffe&scoped=true&"
import script from "./evaluate.vue?vue&type=script&lang=js&"
export * from "./evaluate.vue?vue&type=script&lang=js&"
import style0 from "./evaluate.vue?vue&type=style&index=0&id=884fbffe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884fbffe",
  null
  
)

export default component.exports